import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader, TrueFalseRadio } from "../../SharedComponents";
import { EWizardLinterStatus, WizardLinter } from "../../../../../../../Shared/Process/Process/WizardLinter";
import { EWizardLinterHelper } from "../../../Resource/EWizardLinterHelper";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { incomePaymentDetailsLabels } from "../../../../Common/SIPP/IncomePaymentDetails/Resource/Content";
import { RetirementAge } from "../../../../Common/PaymentsIn/SIPP/RetirementAge";
import { PensionAnnuityAssumption } from "../../../../Common/PaymentsIn/SIPP/PensionAnnuityAssumption";
import { CommonHelper } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { getQueryParameters } from "../../../../../../../Shared/Wizards/Entities/QueryParametersHelper";

interface IJSIPPSectionProps extends IProcessComponentProps {}

interface IJSIPPSectionState {}

export class JSIPPSection extends ProcessComponent<IJSIPPSectionProps, IJSIPPSectionState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    getBlockStatus(data): EWizardLinterStatus {
        let complete = data?.IsIncomePaymentDetailsSelected != null;
        return EWizardLinterHelper.getEWizardLinterStatus(complete);
    }

    private onProductChange(changes, product, index) {
        for (const key in changes) {
            product[key] = changes[key];
        }
        const data = this.props.data.SelectedProducts.concat();
        data[index] = product;
        this.props.onChange({ SelectedProducts: data });
    }

    private getProps(key: string) {
        const { onChange, data, showErrorMsgPopUp, isReview } = this.props;

        return {
            type: key,
            data: data[key],
            isReview: isReview,
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onRef: (ref) => this.appendChild(ref),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
        };
    }

    public render(): JSX.Element {
        const { data } = this.props;

        const productIndex = data.SelectedProducts.findIndex((e) => e.SubAccountType == SubAccountType.JuniorSipp);
        const Product = data.SelectedProducts[productIndex];
        const processType = CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"])
            ? ProcessType.NB
            : ProcessType.NBEC;
            
        return (
            <WizardLinter
                status={this.getBlockStatus(Product)}
                enabled={EWizardLinterHelper.shouldDisplay(SubAccountType.JuniorSipp)}
            >
                {SectionHeader("JSIPP options")}
                {TrueFalseRadio(
                    incomePaymentDetailsLabels.needToProvideAnIncome,
                    "IsIncomePaymentDetailsSelected",
                    Product,
                    (key, value) => {
                        this.onProductChange({ [key]: value }, Product, productIndex);
                    },
                    true,
                    { cssWrapper: "radio-group rg-150 mb-16" }
                )}
                <RetirementAge {...this.getProps("AnnuityAssumptions")} clientInfo={data.ClientDetails} />
                <p className="mb-24">This age/date is used for illustration purposes.</p>

                <PensionAnnuityAssumption processType={processType} {...this.getProps("PensionApply")} />
                <hr className="mb-20" />
            </WizardLinter>
        );
    }
}
